/** *******************************************************************************************************************
 * Copyright (c) 2020 - Fundação CERTI
 * All rights reserved.
 ******************************************************************************************************************* */

import React, {
  useMemo, useEffect, useState, useCallback,
} from 'react';

import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import CompaniesTable from '../../core/CompaniesTable';
import Scaffold from '../../core/Scaffold/Scaffold';
import { getCompanies } from '../../services/companies';
import SamplersPanel from '../../core/CompaniesTable/SamplersPanel';
import { getSamplers, updateAllowedCompanies } from '../../services/companies';

const transformSamplers = (samplersToTransform, companyId) => Object.keys(samplersToTransform).map((roleKey) => ({
  id: samplersToTransform[roleKey].id,
  fullname: samplersToTransform[roleKey].fullname != null ? samplersToTransform[roleKey].fullname : samplersToTransform[roleKey].id,
  value: samplersToTransform[roleKey].allowedCompanies ? samplersToTransform[roleKey].allowedCompanies.includes(companyId) : false,
}));

const Companies = () => {
  const [loading, setLoading] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [samplerUsers, setUsers] = useState([]);
  const [company, setCompany] = useState([]);
  const [openPanel, setOpenPanel] = React.useState(false);

  const handleClosePanel = () => {
    setLoading(false);
    setOpenPanel(false);
  };

  const loadCompanies = async () => {
    const list = await getCompanies();
    setCompanies(
      list?.map((item) => ({
        id: item.id,
        name: item.name,
        customId: item.customId,
        requesterName: item.requester?.fullname,
        crm: item.requester?.professionalCouncil,
        requesterEmail: item.requester?.email,
        cnpj: item.cnpj,
        samplersCount: item.samplersCount,
      })),
    );
  };

  const handleChangeUsers = async (changedSamplers) => {
    setLoading(true);
    setOpenPanel(false);

    const changesCounter = changedSamplers.filter(function (s) { return s.value; }).length -
      changedSamplers.filter(function (s) { return !s.value; }).length;
    setCompanies(
      companies.map((item) => {
        if (item.id === company.id) {
          item.samplersCount = (item.samplersCount === undefined) ?
            changesCounter : item.samplersCount + changesCounter;
        }
        return item;
      })
    );

    await updateAllowedCompanies(company.id, changedSamplers);
    setLoading(false);
  };

  const handleShowModal = useCallback(
    async (id) => {
      setLoading(true);
      setOpenPanel(true);
      const company = companies.find((item) => item.id === id);
      setCompany(company);

      const { data } = await getSamplers();
      if (!data) {
        return;
      }

      setUsers(transformSamplers(data, id));
      setLoading(false);
    },
    [setOpenPanel, companies, setCompany],
  );

  useEffect(() => {
    const call = async () => {
      setLoading(true);
      await loadCompanies();
      setLoading(false);
    };
    call();
  }, []);

  const companiesData = useMemo(
    () => ({
      columns: [
        { title: 'Empresa', field: 'name' },
        { title: 'CNPJ', field: 'cnpj' },
        { title: 'Código do cliente', field: 'customId' },
        { title: 'Coletores autorizados', field: 'samplersCount', editable: 'never' },
        { title: 'Requisitante', field: 'requesterName' },
        { title: 'CRM do requisitante', field: 'crm' },
        { title: 'Email do requisitante', field: 'requesterEmail' },
      ],
      data: companies,
    }),
    [companies],
  );

  return (
    <Scaffold title="Empresas">
      <CompaniesTable
        companiesData={companiesData}
        setCompaniesData={setCompanies}
        handleShowModal={handleShowModal}
        isLoading={loading}
      />
      <SamplersPanel
        comapanyName={company.name}
        samplerUsers={samplerUsers}
        open={openPanel}
        onClose={handleClosePanel}
        onConfirm={handleChangeUsers}
        isLoading={loading}
      />
    </Scaffold>
  );
};

export default withRouter(Companies);
